import React from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';

import Card from './Card';

import * as ST from './styled';

const options = [
    {
        title: 'Кастомизация',
        description: 'Уникальные возможности собрать пакет услуг под свои интересы и потребности',
        icon: 'e900',
    },
    {
        title: 'Бесплатный Wi-Fi',
        description: 'Дарим безлимитный интернет в кафе, кинотеатрах через приложение «<a href="https://dom.ru/internet/wifi">Дом.ру Wi‑Fi</a>». Всего более 9000 точек в РФ',
        icon: 'e613',
    },
    {
        title: '84 HD-канала',
        description: 'Максимальное количество каналов высокой четкости среди федеральных телеком-операторов.',
        icon: 'e605',
    },
    {
        title: '100 Мбит/с',
        description: 'С 02:00 до 10:00 увеличиваем скорость интернета до 100 Мбит/с на всех тарифах.',
        icon: 'e63a',
    },
    {
        title: 'Круглосуточная поддержка',
        description: 'Через чат на сайте, «Вконтакте», Facebook или по телефону.',
        icon: 'e616',
    },
    {
        title: 'Мониторинг 24/7',
        description: 'Автоматически выявляем и ликвидируем сбои до обнаружения их клиентом.',
        icon: 'e641',
    },
];

interface IServices {
    request: (url: string) => void,
}

const Services = ({ request }: IServices) => {

    return (
        <ST.Advantages>
            <ST.Title>Преимущества</ST.Title>
            <ST.Container>
                {options.map((item, index) => (
                    <Card key={index}
                        title={item.title}
                        description={item.description}
                        icon={item.icon}
                    />
                ))}
                <Button onClick={() => request('request')}>Подключить Дом.ру</Button>
            </ST.Container>
        </ST.Advantages>
    );
};

export default Services;
